import { render, staticRenderFns } from "./GroupRowDetails.vue?vue&type=template&id=037a52aa"
import script from "./GroupRowDetails.vue?vue&type=script&lang=ts"
export * from "./GroupRowDetails.vue?vue&type=script&lang=ts"
import style0 from "./GroupRowDetails.vue?vue&type=style&index=0&id=037a52aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports